export default !!navigator.userAgent.match(/Android/i);
